import { Injectable } from '@angular/core';
import { HttpRequestService } from '../_common/http-request.service';

@Injectable()
export class TradeHistoryService {

    constructor(private http: HttpRequestService) { }

    gets(parameters) {
        return this.http.get('tradehistory', parameters)
            .map(res => {
                return res.json();
            })
    }

}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/trade-history.service.ts